import { request } from "@/utilities/libs/request.ts";
import {
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { ERequestMethods } from "@/utilities/enums/RequestMethod.ts";
import { transformFilterQueriesToObject } from "../functions/query";
import { IInvoice } from "../types/Invoice";
import { E_INVOICE } from "../enums/Invoice";

function getInvoiceList({ queryParams }: IRequestArgs) {
  const filterQueries = queryParams?.query?.filter;

  const transformQueries = transformFilterQueriesToObject(filterQueries || []);
  const query = {
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
    ...transformQueries,
  };
  return request<ListResponseData<IInvoice>>({
    method: ERequestMethods.GET,
    url: E_INVOICE.MAIN(),
    params: query,
  });
}

function getInvoiceById(id: string) {
  return request<IResponseData<IInvoice>>({
    method: ERequestMethods.GET,
    url: E_INVOICE.BY_ID(id),
  });
}

const InvoiceRepository = Object.freeze({
  getInvoiceList,
  getInvoiceById,
});

export default InvoiceRepository;
